import { render } from "./InjuryTypeAlysis.vue?vue&type=template&id=2ff08bca&scoped=true"
import script from "./InjuryTypeAlysis.vue?vue&type=script&lang=js"
export * from "./InjuryTypeAlysis.vue?vue&type=script&lang=js"

import "./InjuryTypeAlysis.vue?vue&type=style&index=0&id=2ff08bca&lang=scss&scoped=true"
import "./InjuryTypeAlysis.vue?vue&type=style&index=1&id=2ff08bca&lang=scss&scoped=true"
import "./InjuryTypeAlysis.vue?vue&type=style&index=2&id=2ff08bca&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff08bca"]])

export default __exports__